// ====================================
// ProgressTracking.jsx
// ====================================
import React from 'react';
import Icon from '@/components/AppIcon';

const ProgressTracking = ({ plan, currentProfile, targetRole }) => {
const calculateOverallProgress = () => {
if (!plan?.phases) return 0;
const completed = plan.phases.filter(p => p.status === 'completed').length;
return Math.round((completed / plan.phases.length) * 100);
};

const progress = calculateOverallProgress();

return (
<div className="bg-card border border-border rounded-lg p-6">
<h3 className="text-lg font-semibold text-text-primary mb-4">Progress Overview</h3>

<div className="mb-6">
<div className="flex items-center justify-between mb-2">
<span className="text-sm text-text-secondary">Overall Progress</span>
<span className="text-sm font-medium text-text-primary">{progress}%</span>
</div>
<div className="w-full bg-muted rounded-full h-3">
<div
className="bg-primary h-3 rounded-full transition-all duration-300"
style={{ width: `${progress}%` }}
/>
</div>
</div>

<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
<div className="text-center p-4 bg-muted rounded-lg">
<Icon name="Target" className="text-primary mx-auto mb-2" size={24} />
<p className="text-2xl font-bold text-text-primary">{plan?.phases?.length || 0}</p>
<p className="text-xs text-text-secondary">Total Phases</p>
</div>

<div className="text-center p-4 bg-muted rounded-lg">
<Icon name="CheckCircle" className="text-success mx-auto mb-2" size={24} />
<p className="text-2xl font-bold text-text-primary">
{plan?.phases?.filter(p => p.status === 'completed').length || 0}
</p>
<p className="text-xs text-text-secondary">Completed</p>
</div>

<div className="text-center p-4 bg-muted rounded-lg">
<Icon name="Clock" className="text-warning mx-auto mb-2" size={24} />
<p className="text-2xl font-bold text-text-primary">
{plan?.estimatedDuration || 'N/A'}
</p>
<p className="text-xs text-text-secondary">Est. Duration</p>
</div>
</div>
</div>
);
};

export default ProgressTracking;